import { useState, forwardRef, useImperativeHandle } from 'react';
import MassBalanceForm                           from './MassBalanceForm';
import api                                       from '../../services/api';
import { useUser }                               from '../../contexts/UserContext.js';
import { useMassBalancePage }                    from '../../contexts/MassBalancePageContext.js';

const MassBalanceContainer = forwardRef((props, ref) => {
  
    
    const [ files,        setFiles     ] = useState([]);
    const [ errorMessage, setErrorMessage] = useState(null);
    const [ loading,      isLoading     ] = useState(false);
    const [ isModalOpen,  setIsModalOpen] = useState(false);

    const { userData } = useUser();
    const { isFormOpen, setFormOpen } = useMassBalancePage();

    const handleModalFileClose = () => {
        setIsModalOpen(false);
        setFiles([]);
        setErrorMessage(null);
    };

    const handleModalFileOpen = () => {
        setIsModalOpen(true);
        setFormOpen(true);
    };

    useImperativeHandle(ref, () => ({
        handleModalFileOpen
    }));

    const handleFormSubmit = async (data) => {
  
        try {
            console.log("userData ", userData)
            setErrorMessage(null);
            isLoading(true);
            
            const formData = new FormData();
            formData.append('excelFile', data.excelFile);
            formData.append('userId', userData.id);

            const response = await api.post('/createMassBalance', formData);

            if (response.status == 200){
                handleModalFileClose();
            }
            else{
                setErrorMessage(response.data.message)
            }


        } catch (error) {
            console.log(error)
            setErrorMessage(error?.response?.data?.message || 'Erro ao enviar o arquivo de balanço de massa.');
        } finally {
            isLoading(false);
        }
    };

    return (
        <>
            <MassBalanceForm
                isOpen={isModalOpen}
                onClose={handleModalFileClose}
                onSubmit={handleFormSubmit}
                files={files}
                setFiles={setFiles}
                errorMessage={errorMessage}
                isloading={loading}
            />
        </>
    );
});

MassBalanceContainer.displayName = 'MassBalanceContainer';

export default MassBalanceContainer;
